import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import { BorderedCard } from 'components/BorderedCard';

import { concatWithDot } from 'helpers/string';

import { ComparisonFeatures } from '../ComparisonFeatures';
import { FeaturesList } from '../FeaturesList';
import { COMPETITORS_COMPARISON_NAMES, featuresForComparisonValues } from '../utils/form';

export const CompetitorComparison: FC<{ name: string; disabled: boolean }> = memo(({ name, disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextInputControl
            control={control}
            name={concatWithDot(name, COMPETITORS_COMPARISON_NAMES.PRODUCT)}
            id={concatWithDot(name, COMPETITORS_COMPARISON_NAMES.PRODUCT)}
            label={t('marketAnalysisForm.competitors.productsCompareButtonText')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={12}>
          <FormSectionFilledCard title={t('marketAnalysisForm.competitors.featuresForComparison')}>
            <ComparisonFeatures
              name={name}
              disabled={disabled}
            />
          </FormSectionFilledCard>
        </Grid>
        <Grid item xs={12}>
          <BorderedCard>
            <FeaturesList name={name} disabled={disabled} />
          </BorderedCard>
        </Grid>
        <Grid item xs={12}>
          <FieldArrayComponent
            name={concatWithDot(name, COMPETITORS_COMPARISON_NAMES.COMPETITOR_FEATURES_LIST)}
            buttonText={t('marketAnalysisForm.competitors.qualitiesButtonText')}
            initialItem={featuresForComparisonValues}
            disabled={disabled}
            maxLength={4}
          >
            {(namePrefix) => (
              <FormSectionFilledCard>
                <FeaturesList name={name} namePrefix={namePrefix} disabled={disabled} />
              </FormSectionFilledCard>
            )}
          </FieldArrayComponent>
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
